export const mindmap =
    {
        noMailMenu: true,
    };